__turbopack_context__.v({
  "bar": "tab-bar-module__pfYnwW__bar",
  "inner": "tab-bar-module__pfYnwW__inner",
  "mark": "tab-bar-module__pfYnwW__mark",
  "pill": "tab-bar-module__pfYnwW__pill",
  "tab": "tab-bar-module__pfYnwW__tab",
});
